import moment from "moment";
import {
	debounce,
	find,
	findIndex,
	filter,
	some,
	forEach,
	intersectionWith
} from "lodash";
import template from "./simple-selection.html";
import "./simple-selection.less";
import {
	EVENT_REPORT_SAVED,
	EVENT_FIELD_DISABLE,
	EVENT_FILTER_CURRENT_OPTIONS,
	EVENT_FILTER_ALL_OPTIONS,
	EVENT_REMOVE_OPTIONS,
	EVENT_LOAD_OPTIONS,
	EVENT_VALUE_CHANGED,
	EVENT_REPORT_LOCKED,
	EVENT_REPORT_UNLOCKED,
	EVENT_SET_VALUE,
	EVENT_CLEAR_VALUE,
	EVENT_UNCLEAR_VALUE,
	EVENT_GET_VALUE,
	EVENT_SEND_VALUE,
	EVENT_HOTKEY_LOCK,
	EVENT_HANDLE_SUCCESSOR_LOCK,
	EVENT_ENABLE_SUCCESSOR_LOCK,
	EVENT_DISABLE_SUCCESSOR_LOCK,
	FEATURE_TYPES,
	PIVOT_TYPES,
	EVENT_EXPAND_MULTI_ENTRY_LIST,
	EVENT_TIMEZONE_SET,
	EVENT_REVERT_VALUES,
	EVENT_SET_FORM_PRISTINE,
	EVENT_FILTER_PRIMARYDATE,
	IS_NOT_AVAILABLE_VALUE
} from "constants.js";
import { FORM_USER_FAVORITES } from "routes";

import { customInputWarning } from "../prompts/customInputWarning";
import { entityFound } from "../prompts/entityFound";
import {
	ENGINE_EVALUATIONS,
	ENGINE_TYPES
} from "../../../../screens/rule-provider/constants";
import fieldHelpers from "../../../field-helpers/lookup.config";
import { IS_NOT_AVAILABLE_OPTIONS } from "../../../../constants";
import {
	alertDeactivatedSelection,
	notifyMultipleEntityTimezoneError,
	notifyNoEntityTimezoneError
} from "../../../manage-report/prompts";
import { UNIQUE_TIMEZONE_ERRORS } from "../../../../services/entity-manager";
import { isStringNullishOrEmpty } from "../../../../services/string-service";
import { isValueNullish } from "../../../../utils/valueUtilities";
import { getFieldUsageDefault } from "../../../../utils/dataUsage";
export class Controller {
	options = [];
	lookups = [];
	uiHelpers = null;
	LONG_TERM_DEACTIVATION_DAYS = 45;

	constructor(
		$scope,
		uiHelpers,
		featureHelper,
		$timeout,
		entityManager,
		$window,
		$element,
		$logger,
		appState,
		featureCallbacks,
		toastr,
		api,
		$userProfile,
		loadingService
	) {
		this._scope = $scope;
		this.uiHelpers = uiHelpers;
		this.featureHelper = featureHelper;
		this.filteredData = {};
		this.entityManager = entityManager;
		this.$timeout = $timeout;
		this.$window = $window;
		this.$element = $element;
		this.$logger = $logger;
		this.appState = appState;
		this.featureCallbacks = featureCallbacks;
		this._toastr = toastr;
		this.api = api;
		this.$userProfile = $userProfile;
		this.loadingService = loadingService;
		this.runOnReady = [];
	}

	$onInit() {
		const self = this;
		this._eventBus = this.reportScope.events;
		this.cleared = undefined;

		this.textFieldId = `textInput-${this.field.Id}`;
		this.selectFieldId = `select-${this.field.Id}`;

		this.field.showExpand = false;
		this.isFocused = false;
		this.setOptionIdType();

		this.registerEvents();

		this.initialValue = find(this.values, v => v.FieldId === this.field.Id);
		this.initialValue && (this.initialValue.IsNotAvailable = !!this.initialValue.IsNotAvailable); //coerce isnotavailable to false if it doesn't exist

		if(this.isThisValueInNewForm() || this.initialValue) {
			this.setValue();
		}
		if(this.isThisValueInNewForm()) {
			this.setPristine();
		}

		this.loadFieldData();

		this.initialValueSet = true;
		this.setFeatures();

		this.hasHelperButtons = !!this.lookups.length;

		this._scope.$watch(
			() => this.field.filters,
			(next) => {
				const self = this;
				if(next && Object.getOwnPropertyNames(next).length > 0) {
					Object.keys(next).map((key) => {
						if(Object.prototype.hasOwnProperty.call(next, key)) {
							self.updateFilteredData(key, next[key] && next[key][0]._code);
						}
					});
					this.filterOptions();
				}
			},
			true
		);

		this._scope.$watch(() => this.value, debounce((next) => {
			if(!isValueNullish(this.suppressMatchValue) && !isValueNullish(next)) {
				const isRestoredValue = next === this.suppressMatchValue;
				this.suppressMatchValue = undefined;
				if(isRestoredValue) {
					return;
				}
			}

			if(this.isCustomInput !== true || isValueNullish(next) || next === this.initialValue?.String) {
				return;
			}

			const match = this.findActiveDataItem(this.allOptionsIncludingUnfavorited, next);
			if(match) {
				let renderingSlots = this.uiHelpers.getDefaultEntitySlots(match, undefined, this.field.IsCodeHidden, true);
			
				if(this.field.RenderingDirectives?.Display?.Selected) {
					renderingSlots = this.uiHelpers.getRenderingSlots(match, this.field.RenderingDirectives?.Display?.Selected);
				}
			
				entityFound(this.field, renderingSlots, this.$logger)
					.then(result => {
						if(!result?.dismiss) {
							const revertVal = this.value;
							
							this.setCustomInput(false);

							self.handleAdvancedSearchAction(match)
								.then(applied => {
									if(!applied) {
										this.activateCustomInput();
										// suppress one watcher pass so the programmatically restored value does not re-open the match modal
										this.suppressMatchValue = revertVal;
										this.value = revertVal;
										this.handleCustomInputChanged();

										return;
									}

									self.updateCustomInputState(false);
									self.enableHelpers();

									self.$timeout(function() {
										window.document.getElementById(self.selectFieldId).focus();
									});
								})
								.catch(() => {
									this._toastr.error(`An error occurred while adding the ${this.field.Name}.`);
								});
						}
					});
			}
		}, 200, {
			leading: false,
			trailing: true
		}));

		if(this.field.Pivot && this.field.Pivot !== PIVOT_TYPES.Repeat) {
			this._scope.$watch(
				() => (self.options.length > 1) && !self.field.isDisabled && !self.field.isReadonly && (self.$window.innerWidth > 992),
				(next) => {
					let show = next;

					if(self.field.Pivot === PIVOT_TYPES.RecentlyUsed) {
						const hasSomeRecents = some(self.options, o => o.IsRecent === true);
						show = show && hasSomeRecents;
					}

					self.field.showExpand = show;
					self.hasHelperButtons = !!self.lookups.length || (self.field.showExpand && self.field.allowPivot);
				},
				true
			);
		}
	}

	isItemFavorited = (item) => {
		if(item.IsFavorite) {
			return true;
		}

		if(item.Entities?.length) {
			return item.Entities.some(e => this.isItemFavorited(e.Entity));
		}

		return false;
	};

	loadFieldData = () => {
		let dataToFilter = this.field.Data || [];
		const selectedItemId = this.initialValue?.DataId ?? this.initialValue?.EntityId;

		dataToFilter = this.filterByDeactivationStatus(dataToFilter, selectedItemId);
		this.allOptionsIncludingUnfavorited = dataToFilter;

		if(this.field.IsFavoriteEnabled) {
			this.options = dataToFilter.filter(this.isItemFavorited);
			const hasInitialValue  = this.options.some(o => o.Id === this.initialValue?.DataId || o.Id === this.initialValue?.EntityId);
			if(this.initialValue && !hasInitialValue && this.initialValue.String === undefined && !this.initialValue.IsNotAvailable) {
				const initialDataItem = dataToFilter.find(d => d.Id === this.initialValue?.DataId || d.Id === this.initialValue?.EntityId);
				if(initialDataItem) {
					this.options.push(initialDataItem);
				}
			}
		}
		else {
			this.options = dataToFilter;
		}

		return this.options;
	};

	isSelectionValid = (selection) => selection?.Id !== undefined && selection?.Id !== null;

	isThisValueInNewForm = () => {
		if(this.field.IsDetail) {
			return this.values === undefined;
		}

		return !!this.reportScope.isNew;
	};

	registerEvents() {
		const ctrl = this;
		if(!this.subFieldCtrl) {
			this._unregister = this.reportFormCtrl.registerFieldController(this);
		}
		else {
			this._unregister = this.subFieldCtrl(this);
		}

		this._eventBus.register(EVENT_REPORT_SAVED, () => {
			if(this.field.IsRecentlyUsedEnabled) {
				this.box.setChoices();
			}
		}, this._scope);

		this._eventBus.register(EVENT_FILTER_CURRENT_OPTIONS(this.field.Id), (e, params) => {
			if(!params.readonly && this.isNotAvailable !== true) {
				this.enableField();
			}
			this.setOptions(params);
			if(params.readonly) {
				this.field.isDisabled = true;
				this.disableField();
				this.triggerValueChanged();
			}
			else if(((this.isSelectionValid(ctrl.selection) || this.isNotAvailable === true) && params.forceTrigger) || params.clear) {
				this.triggerValueChanged(ctrl.selection, true);
			}
		}, this._scope);

		this._eventBus.register(EVENT_FILTER_ALL_OPTIONS(this.field.Id), (e, params) => {
			this.enableField();

			this.setOptions(params);
		}, this._scope);

		this._eventBus.register(EVENT_HOTKEY_LOCK, () => {
			return ctrl.isFocused && ctrl.field.IsLockable && (ctrl.field.isLocked = !ctrl.field.isLocked);
		}, this._scope);

		this._eventBus.register(EVENT_HANDLE_SUCCESSOR_LOCK(this.field.Id), (e, params) => {
			this.field.isFieldLockable = params.enable && this.field.IsLockable;
			if(this.field.isFieldLockable !== true) {
				this.field.isLocked = false;
				this._eventBus.trigger(EVENT_DISABLE_SUCCESSOR_LOCK(this.field.Id));
			}
			else {
				this.triggerLockUpdate();
			}
		}, this._scope);

		this._eventBus.register(EVENT_REMOVE_OPTIONS(this.field.Id), (e, params) => {
			this.removeOptions(params.items);
			this._scope.$apply();
		}, this._scope);

		this._eventBus.register(EVENT_LOAD_OPTIONS(this.field.Id), (e, params) => {
			const dataItems = params?.data || [];
			if(!this.isSelectionValid(this.selection)) {
				this.enableField();
			}
			else {
				const newOptionIds = (Array.isArray(dataItems) && dataItems.map((item) => item.Id)) || null;
				if(!newOptionIds || newOptionIds.indexOf(this.selection.Id) < 0) {
					this.clearSelected();
					this.selection = {};
					this.isNotAvailable = false;
					this.value = null;
				}
			}
			this.field.Data = dataItems;
			this.setChoices(dataItems);
			const activeParams = dataItems.filter(param => param.IsActive !== false);
			if(activeParams.length === 1 && !params.suppressAutoselect) {
				this.value = activeParams[0].Id;
				this.setChoice(activeParams[0]);
			}
			else if(dataItems.length > 1) {
				const selection = find(dataItems, (param) => param.Id === this.value);
				this.setChoice(selection);
			}
		}, this._scope);

		this._eventBus.register(EVENT_SET_VALUE(this.field.Id), (_, params) => {
			this.setValue(params.value);
			if(this.isSelectionValid(this.selection)) {
				this.enableField();
				this.setChoice(this.selection);
			}
			else {
				this.clearSelected();
			}
		}, this._scope);

		this._eventBus.register(EVENT_GET_VALUE(this.field.Id), (_, params) => {
			this._eventBus.trigger(EVENT_SEND_VALUE(params.id), {
				key: this.field.Key.Code,
				value: this.getCurrentValue()
			});
		}, this._scope);

		this._eventBus.register(EVENT_CLEAR_VALUE(this.field.Id), (_, params) => {
			if(!this.cleared && (this.value !== undefined || !!this.isSelectionValid(this.selection) || !!this.isNotAvailable || !!this.isCustomInput)) {
				if(params.isInitializing !== true) {
					this.cleared = {
						value: this.value,
						selection: this.selection,
						isNotAvailable: this.isNotAvailable,
						isCustomInput: this.isCustomInput,
						lastValue: this.lastValue
					};
				}

				this.clearSelected();
				this.selection = {};
				if(this.isCustomInput && !this.field.isLocked) {
					this.setCustomInput(false);
					const customHelper = find(this.lookups, l => l.name === fieldHelpers.CustomInput.name);
					customHelper && (customHelper.selection = false);
				}
				this.isNotAvailable = false;
				this.value = null;
				this.lastValue = null;

				this.updateFieldDirty();

				if(params.isInitializing && (this.reportScope.isNew || this.initialValue)) {
					this.setValue();
					this.setChoice(this.selection);
				}
			}
		}, this._scope);

		this._eventBus.register(EVENT_UNCLEAR_VALUE(this.field.Id), () => {
			if(!!this.cleared) {
				this.selection = this.cleared.selection;

				if(this.cleared.isCustomInput && !this.field.isLocked) {
					this.isCustomInput = this.cleared.isCustomInput;
					const customHelper = find(this.lookups, l => l.name === fieldHelpers.CustomInput.name);
					customHelper && (customHelper.selection = this.cleared.isCustomInput);
				}
				this.isNotAvailable = this.cleared.isNotAvailable;
				this.value = this.cleared.value;
				this.setChoice(this.selection, true);
				this.lastValue = this.cleared.lastValue;

				this.cleared = undefined;

				this.updateFieldDirty();
			}
		}, this._scope);

		this._eventBus.register(EVENT_FIELD_DISABLE(this.field.Id), () => {
			this.field.isDisabled = true;
			this.disableField();
		}, this._scope);

		this._eventBus.register(EVENT_REPORT_LOCKED, () => {
			this.field.isReadonly = true;
			this.disableField();
		}, this._scope);

		this._eventBus.register(EVENT_REPORT_UNLOCKED, () => {
			this.field.isReadonly = false;
			this.enableField();
		}, this._scope);

		this._eventBus.register(EVENT_REVERT_VALUES, () => {
			this.revertValue();
		}, this._scope);

		this._eventBus.register(EVENT_SET_FORM_PRISTINE, () => {
			this.setPristine();
		}, this._scope);

		if(this.field.EntityQueryConfiguration?.Friendly?.IncludeEffectiveRanges ?? this.field.EntityQueryConfiguration?.Primary?.IncludeEffectiveRanges) {
			this._eventBus.register(EVENT_FILTER_PRIMARYDATE, (e, params) => {
				if(this.isReady) {
					this.filterDataOnPrimaryDate(params.effectiveAsOf, params.autoSelect);
				}
				else {
					this.runOnReady.push(() => this.filterDataOnPrimaryDate(params.effectiveAsOf, params.autoSelect));
				}
			}, this._scope);
		}
	}
	
	findActiveDataItem = (data, value) => { 
		const normalizedValue = value?.toLowerCase();
		if(normalizedValue === undefined || normalizedValue === null || normalizedValue === "") {
			return false;
		}

		const activeItems = (data ?? []).filter((item) => {
			if(item.IsActive === false || this.isDeactivated(item.DeactivatedAt)) {
				return false;
			}

			return true;
		});

		const foundByCode = activeItems.filter((item) => {
			return item.Code?.toLowerCase() === normalizedValue;
		});

		const foundByIdentifier = activeItems.filter((item) => {
			return item.Identifiers?.some(identifier => identifier.Value?.toLowerCase() === normalizedValue);
		});

		if(foundByCode.length === 1) {
			return foundByCode[0];
		}

		if(foundByIdentifier.length === 1) {
			return foundByIdentifier[0];
		}

		return undefined;
	};

	isSelectionEligible = (selection) => {
		if(selection?.Id === undefined || selection?.Id === null) {
			return false;
		}

		return (this.allOptionsIncludingUnfavorited ?? []).some(item =>
			item.Id === selection.Id
			&& item.IsActive !== false
			&& !this.isDeactivated(item.DeactivatedAt)
		);
	};

	triggerLockUpdate() {
		const event = this.field.isLocked ? EVENT_ENABLE_SUCCESSOR_LOCK(this.field.Id) : EVENT_DISABLE_SUCCESSOR_LOCK(this.field.Id);
		this._eventBus.trigger(event);
	}

	$onDestroy() {
		this._unregister && this._unregister();
	}

	enableField() {
		if(this.field.hasEffectiveRanges && this.effectiveAsOf === undefined && this.isCustomInput !== true) {
			return;
		}

		this.field.isDisabled = false;

		if(!this.field.isReadonly) {
			if(!this.isNotAvailable) {
				this.field.placeHolder = null;
				this.box && this.box.enable();
			}
			this.$timeout(() => {
				this.enableHelpers();
				this.setHelpersBasedOnState();
			});
		}
	}

	disableField() {
		if(this.field.isDisabled || this.field.isReadonly) {
			this.disableInput();
			this.disableHelpers();
		}
	}

	disableInput() {
		this.field.isDisabled = true;
		this.box && this.box.disable();
	}

	setDisplay(id) {
		const item = find(this.options, { Id: parseInt(id) });

		if(!item) {
			throw new Error(`Selected ${this.field.Name} not found as an option.`);
		}

		this.hasSecondRowDirective = !!this.field.RenderingDirectives?.Display?.Selected?.[2];
		const selectedItemDirectives = {
			"hidden-print": this.field.RenderingDirectives?.Display?.Selected,
			"not-printing-hidden": this.field.RenderingDirectives?.Print ?? this.field.RenderingDirectives?.Display?.Selected
		};

		const entityDisplay = this.uiHelpers.getEntityDisplay(item, undefined, true, true, selectedItemDirectives);

		return entityDisplay;
	}

	setBox(box) {
		this.box = box;

		if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always)) {
			this.setNotAvailable(this.isNotAvailable, true);
		}

		this.setOptions();

		if(this.isSelectionValid(this.selection)) {
			this.setChoice(this.selection);
		}

		this.isReady = true;
		this.runOnReady.forEach(func => func());
		this.runOnReady = [];
	}

	setOptions(params) {
		if((params || {}).clear) {
			this.options = [];
			this.allOptionsIncludingUnfavorited = [];
			this.filterEnableNA = false;
		}
		else if(params?.ids) {
			const filteredByIds = filter(this.field.Data, (d) => some(params.ids, (i) => d.Id === i));

			const selectedItemId = this.initialValue?.DataId ?? this.initialValue?.EntityId;
			this.options = this.filterByDeactivationStatus(filteredByIds, selectedItemId);
			this.allOptionsIncludingUnfavorited = this.options;

			this.filterEnableNA = some(params.ids, o => o === IS_NOT_AVAILABLE_VALUE);
		}
		else {
			this.loadFieldData();
			this.filterEnableNA = this.isNotAvailable;
		}

		this.postOptionsChange((params || {}).isFromInitialValue);
	}

	removeOptions(opts) {
		if(opts && opts.length && opts.length > 0) {
			this.options = this.options.filter(o => opts.indexOf(o.Id) < 0 || (this.selection && o.Id === this.selection.Id));
			this.postOptionsChange();
		}
	}

	updateFilteredData(type, value) {
		if(value) {
			const compareTo = {};
			compareTo.value = parseInt(value);

			const filteredData = filter(this.field.Data, (d) => {
				return ENGINE_EVALUATIONS[ENGINE_TYPES.COMPARE.function][type]([parseInt(d.Code)], compareTo);
			});

			this.filteredData[type] = filteredData;
		}
		else {
			this.filteredData[type] = this.field.Data;
		}
	}

	filterOptions() {
		const filteredDataArray = [];
		Object.keys(this.filteredData).map((key) => {
			if(Object.prototype.hasOwnProperty.call(this.filteredData, key)) {
				filteredDataArray.push(this.filteredData[key]);
			}
		});

		filteredDataArray.push((optionOne, optionTwo) => {
			return optionOne.Code === optionTwo.Code;
		});

		this.options = intersectionWith.apply(null, filteredDataArray);
		this.allOptionsIncludingUnfavorited = this.options;

		this.postOptionsChange();
	}

	postOptionsChange(initializing) {
		if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.supported)) {
			if(this.filterEnableNA !== true) {
				this.forcedNA = false;
				this.removeIsNotAvailableFeature();
				if(this.options && this.options.length > 0 && !this.field.isReadonly) {
					this.box && this.box.enable();
					this.enableHelpers();
				}
			}
			else if(this.options === undefined || this.options.length === 0) {
				this.forcedNA = true;
				this.setupIsNotAvailableFeature(true, true);

				this.setNotAvailable(true, true);
				this.updateNotAvailableState(true);
				this.disableHelpers();
			}
			else {
				if(this.forcedNA) {
					this.isNotAvailable = false;
				}
				this.setupIsNotAvailableFeature(true, false);
				const retainValue = this.isNotAvailableFeatureEnabled || initializing;
				!this.field.isReadonly && this.enableHelpers();

				this.setNotAvailable(this.isNotAvailable === undefined ? undefined : this.isNotAvailable && !!retainValue, true);
				this.updateNotAvailableState(this.isNotAvailable && !!retainValue);
				this.forcedNA = false;
			}
		}
		else if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.never)) {
			this.isNotAvailable = false;
			this.setNotAvailable(false);
			this.removeIsNotAvailableFeature();
		}
		else {
			this.setNotAvailable(this.isNotAvailable);
			this.updateNotAvailableState(this.isNotAvailable);
		}

		if(!this.isCustomInput && this.isSelectionValid(this.selection) && !some(this.options, (o) => o.Id === this.selection.Id)) {
			this.clearSelected();
			this.selection = {};

			this.value = undefined;
			this.handleValueChanged();
		}

		this.setChoices();

		if(
			(this.options || []).length === 1
			&& this.isNotAvailable !== true
			&& this.isCustomInput !== true
			&& this.field.visible !== false
		) {
			const newSelection = this.options[0];
			if(newSelection?.Id !== this.selection?.Id) {
				this.selection = newSelection;
				this.filterEnableNA && this.setNotAvailable(false);
				this.filterEnableNA && this.updateNotAvailableState(false);

				this.value = this.selection.Id;
				this.setChoice(this.selection);
			}
		}
	}

	clearSelected() {
		if(!this.isCustomInput && this.box) {
			const values = this.box.getValue(true);
			this.box.removeItemsByValue(values);
		}
		else {
			this.value = "";
		}
	}

	setChoice(choice, silent = false) {
		if(this.isSelectionValid(choice)) {
			if(choice.IsActive === false || this.isOutdatedOption(choice)) {
				const deletedChoice = this.uiHelpers.setDisplay(
					[choice],
					{
						recentlyUsedEnabled: this.field.IsRecentlyUsedEnabled,
						hideCode: this.field.IsCodeHidden,
						isRemoved: this.isOutdatedOption
					}
				);
				const currentValue = this.box.getValue(true);
				if(deletedChoice[0].value != currentValue) {
					this.box && this.box.setChoices(deletedChoice, "value", "label", false);
				}
			}

			this.box && this.box.setValueByChoice(choice.Id.toString());
		}
		if(!silent) {
			this.handleValueChanged();
		}
	}

	setChoices(data) {
		if(data) {
			this.options = data;
			this.allOptionsIncludingUnfavorited = data;
		}

		if(!this.options || !Array.isArray(this.options)) {
			this.box.clearStore();
			return;
		}

		const activeOptions = this.options.filter((option) =>
			(option.IsActive || option.IsActive === undefined) || this.isOutdatedOption(option)
		);

		const listRenderingDirectives = this.field.RenderingDirectives?.Display?.List;
		const selectionChoices = this.uiHelpers.setDisplay(
			activeOptions,
			{
				recentlyUsedEnabled: this.field.IsRecentlyUsedEnabled,
				hideCode: this.field.IsCodeHidden,
				isRemoved: this.isOutdatedOption
			},
			listRenderingDirectives
		);

		if(this.field.Pivot === PIVOT_TYPES.RecentlyUsed) {
			const recentOptions = this.options.filter(o => o.IsRecent === true);

			this.field.showExpand = this.field.showExpand && recentOptions.length > 1;
		}
		this.hasHelperButtons = !!this.lookups.length || (this.field.showExpand && this.field.allowPivot);

		if(this.box) {
			this.box.setChoices(selectionChoices, "value", "label", true);
		}
	}

	setNotAvailable(selection, initializing = false) {
		if(selection !== undefined && selection === this.isNotAvailable) {
			if(selection === true && !this.isCustomInput) {
				this.disableInput();
				this.disableHelpers(fieldHelpers.NotAvailable.name);
			}
			return;
		}

		const lastVal = this.isNotAvailable;
		if(!this.selection) {
			this.selection = {};
		}

		this.isNotAvailable = selection;

		if(this.isNotAvailable) {
			this.clearSelected();
			this.selection = null;
			this.value = null;
			this.disableInput();
			this.disableHelpers(fieldHelpers.NotAvailable.name);
			if(!this.isCustomInput) {
				this.disableField();
			}
			!initializing && this.disableHelpers(fieldHelpers.NotAvailable.name);
		}
		else if(!this.field.isReadonly && selection !== undefined) {
			if(!this.isCustomInput) {
				this.box && this.box.enable();
				!initializing && this.enableHelpers();
			}
			this.field.isDisabled = false;
		}

		if((this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always) || this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.supported))
			&& lastVal !== this.isNotAvailable) {
			this.triggerValueChanged(selection === true ? { Id: IS_NOT_AVAILABLE_VALUE } : {});
		}
	}

	disableHelpers(exceptedName) {
		this.enableHelpers();
		this.lookups.forEach(l => {
			if(this.reportFormCtrl.readonly || !exceptedName || l.name !== exceptedName) {
				l.disabled = true;
			}
		});
	}

	enableHelpers() {
		this.lookups.forEach(l => l.disabled = false);
	}

	setCustomInput(featureActive) {
		if(featureActive) {
			this.showCustomInputWarning();
			return;
		}
		this.selection = {};
		this.isCustomInput = false;
		this.enableHelpers();
		this.value = null;
		this.handleCustomInputChanged();

		if((this.options || []).length === 1) {
			this.selection = this.options[0];
			this.value = this.selection.Id;
			this.setChoice(this.selection);
		}
	}

	async showCustomInputWarning() {
		const self = this;
		const userAction = await customInputWarning(this.$logger);

		if(userAction.dismiss) {
			this.updateCustomInputState(false);
			this.isCustomInput = false;

			this.$timeout(function() {
				window.document.getElementById(self.selectFieldId).focus();
			});
		}
		else {
			this.activateCustomInput();
		}

		this._scope.$apply();
	}

	activateCustomInput() {
		this.clearSelected();
		this.isCustomInput = true;
		this.selection = null;
		this.value = "";
		this.disableHelpers(fieldHelpers.CustomInput.name);

		this.lastCustomInputValue = null;

		const self = this;
		this.$timeout(function() {
			const txt = window.document.getElementById(self.textFieldId);

			txt.focus();
			txt.select();
		});
	}

	updateCustomInputState(newState) {
		const inputLookup = find(this.lookups, (lookup) => lookup.name === fieldHelpers.CustomInput.name);
		inputLookup.selection = newState;
	}

	updateNotAvailableState(newState) {
		const inputLookup = find(this.lookups, (lookup) => lookup.name === fieldHelpers.NotAvailable.name);
		if(inputLookup) {
			inputLookup.selection = newState;
		}
	}

	setFeatures() {
		this.setupCustomEntryFeature();
		this.setupIsNotAvailableFeature();
		this.setupMapFeature();
		this.setupAdvancedSearchFeature();

		this.setHelpersBasedOnState();
	}

	setHelpersBasedOnState() {
		if(this.isNotAvailable) {
			this.disableHelpers(fieldHelpers.NotAvailable.name);
		}
		else if(this.isCustomInput) {
			this.disableHelpers(fieldHelpers.CustomInput.name);
		}
		else if(this.field.isDisabled || this.field.isReadonly) {
			this.disableHelpers();
		}
	}

	setupCustomEntryFeature() {
		if(this.field.IsCustomEntryEnabled) {
			const feature = this.featureHelper.getCustomInputFeature(this.field, this.isCustomInput, (selection) => this.setCustomInput(selection));
			this.lookups.push(feature);
		}
	}

	setupIsNotAvailableFeature(turnOnFeature, valueSet) {
		if(!this.isNotAvailableFeatureEnabled
			&& (
				this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always)
				|| (
					this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.supported)
					&& turnOnFeature
				)
			)
		) {
			const feature = this.featureHelper.getNotAvailableFeature(this.field, this.isNotAvailable || valueSet, (selection) => this.setNotAvailable(!!selection));
			this.lookups.push(feature);
			this.isNotAvailableFeatureEnabled = true;
		}
	}

	removeIsNotAvailableFeature() {
		if(!!this.isNotAvailableFeatureEnabled) {
			const isNotAvailableFeatureIndex = findIndex(this.lookups, l => l.name === fieldHelpers.NotAvailable.name);
			this.lookups.splice(isNotAvailableFeatureIndex, 1);
			this.isNotAvailableFeatureEnabled = false;
		}
		this.isNotAvailable = false;
	}

	setupMapFeature() {
		const mapFeature = find(this.field.features, { type: FEATURE_TYPES.map });
		if(mapFeature) {
			this.lookups.push({
				name: mapFeature.type,
				fieldId: this.field.Id,
				disabled: this.field.isReadonly || this.field.isDisabled,
				data: mapFeature.data
			});
		}
	}

	setupAdvancedSearchFeature() {
		if(this.field.AdvancedSearchEnabled) {
			this.lookups.push({
				name: fieldHelpers.AdvancedSearch.name,
				fieldId: this.field.Id,
				hideCode: !!this.field.IsCodeHidden,
				disabled: this.field.isDisabled || this.field.isReadonly,
				action: this.handleAdvancedSearchAction,
				options: {
					isFavoriteEnabled: this.field.IsFavoriteEnabled,
					matchSpecificity: this.field.MatchSpecificity
				}
			});
		}
	}

	handleAdvancedSearchAction = async(selection) => {
		if(selection === undefined || !this.isSelectionEligible(selection)) {
			return false;
		}

		if(this.field.IsFavoriteEnabled && selection.IsFavorite !== true) {
			// set favorite on api here.  Currently we favorite the friendly entity.
			const targetType = this.field.EntityQueryConfiguration.Friendly.Type.Code;
			const relationshipType = "SELF";
			const setFavorite = this.api.post(FORM_USER_FAVORITES(
				this.appState.forms.selected.Id,
				this.$userProfile.getUser().databaseId,
				selection.Id,
				targetType,
				relationshipType
			));
			await this.loadingService.watch(setFavorite);

			const thisDataItem = this.field.Data.find(d => d.Id === selection.Id);
			thisDataItem.IsFavorite = true;

			this.entityManager.updateEntity(thisDataItem);
			const thisField = this.appState.forms.selected.Fields.find(f => f.Id === this.field.Id);
			const thisItemIndex = thisField.Data.findIndex(d => d.Id === thisDataItem.Id);
			thisField.Data[thisItemIndex] = thisDataItem;

			this.setOptions();
		}

		if(!this.isSelectionEligible(selection)) {
			return false;
		}

		this.setValue(selection);
		this.box.setValueByChoice(selection.Id.toString());

		return true;
	}

	getCurrentValue(isApiCall = false) {
		let result = this.buildResult();

		if(!isApiCall) {
			if(!result) {
				result = { FieldId: this.field.Id };
				result.hasResultForRuleRun = false;
			}

			result.isDirty = this.isDirty(result);

			if(this.isSelectionValid(this.selection)) {
				if(this.selection.Classifications) {
					const hasUnhydratedClassifications = some(this.selection.Classifications, (c) => (c.Id !== undefined && c.Code === undefined));

					if(hasUnhydratedClassifications) {
						forEach(this.selection.Classifications, (c, $index) => {
							this.selection.Classifications[$index] = this.entityManager.getClassification(c.Code);
						});
					}
				}

				result.Classifications = this.selection.Classifications ?? [];
				result.Identifiers = this.selection.Identifiers ?? [];
				result._code = this.selection.Code;
				result.Order = this.selection.Order;
				result.DeactivatedAt = this.selection.DeactivatedAt;
				result.allCodes = [this.selection.Code];
				result.externalKeys = [this.selection.ExternalKey];
				result.Geometries = this.selection.Geometries ?? [];
				result.Shape = this.selection.Shape;
			}
		}

		return result ? [result] : [];
	}

	revertValue() {
		if(this.box && this.initialValue) {
			this.setValue(this.initialValue);
			this.box && this.value !== undefined && this.box.setValueByChoice(this.value.toString());
		}
	}

	buildResult() {
		let result;
		if(
			this.isSelectionValid(this.selection)
			|| (this.isNotAvailable === true)
			|| (this.isCustomInput === true && !isStringNullishOrEmpty(this.value))
		) {
			result = {
				FieldId: this.field.Id,
				IsNotAvailable: !!this.isNotAvailable
			};
			if(this.isNotAvailable !== true) {
				if(this.isCustomInput === true) {
					result.String = this.value;
				}
				else {
					result[this.optionIdType] = this.selection.Id;
				}
			}
		}
		return result;
	}

	setPristine() {
		this.initialValue = this.buildResult();
	}

	setValue(val) {
		const usageDefault = getFieldUsageDefault(this.field, this.field.Data);
		const value = val ? val :
			find(this.values, v => v.FieldId === this.field.Id)
			|| usageDefault
			|| find(this.field.Data, (item) => item.IsDefault && item.DeactivatedAt === undefined);

		if(!value) {
			return;
		}

		if(!!value.String && this.field.IsCustomEntryEnabled) {
			this.value = value.String;
			this.isCustomInput = true;
			this.lastCustomInputValue = this.value;
		}
		else {
			this.value = value[this.optionIdType] ?? value.Id;
		}
		this.isNotAvailable = value.IsNotAvailable;

		if(this.value !== undefined) {
			this.handleValueChanged();
		}
	}

	handleLookupSelection(lookup) {
		if(lookup.action) {
			lookup.action(lookup.selection);
		}
	}

	isRecentlyDeactivated = (deactivatedDate) => {
		if(!deactivatedDate) {
			return false;
		}
		const deactivatedMoment = moment(deactivatedDate);
		const now = moment();
		const daysDiff = now.diff(deactivatedMoment, "days");
		return daysDiff >= 0 && daysDiff <= this.LONG_TERM_DEACTIVATION_DAYS;
	}

	isLongTermDeactivated = (deactivatedDate) => {
		if(!deactivatedDate) {
			return false;
		}
		const deactivatedMoment = moment(deactivatedDate);
		const now = moment();
		const daysDiff = now.diff(deactivatedMoment, "days");
		return daysDiff > this.LONG_TERM_DEACTIVATION_DAYS;
	}

	isOutdatedOption = (item) => {
		const selectedItemId = this.initialValue?.DataId ?? this.initialValue?.EntityId;
		return !!selectedItemId && item?.Id === selectedItemId && this.isLongTermDeactivated(item?.DeactivatedAt);
	}

	filterByDeactivationStatus = (items, selectedItemId) => {
		return items.filter(item => {
			if(selectedItemId && item.Id === selectedItemId) {
				return true;
			}
			return !this.isLongTermDeactivated(item.DeactivatedAt);
		});
	}

	isDeactivated(date) {
		return date && moment(date).isBefore(moment());
	}

	handleValueChanged(modelVal) {
		if(modelVal !== null && modelVal !== undefined) {
			this.value = modelVal;
			this.initialValueSet = false;

			if(modelVal.trim() === "") {
				this.value = undefined;
				this.selection = {};
			}
		}

		const compareValue = this.lastValue ? this.lastValue : this.initialValue && this.initialValue[this.optionIdType];

		const future = this.options.find(o => o.Id?.toString() === modelVal);
		if(this.isDeactivated(future?.DeactivatedAt) && future?.Id?.toString() !== compareValue?.toString()) {
			alertDeactivatedSelection(future.Name || future.Code);
			this.clearSelected();
			this.selection = {};
			this.isNotAvailable = false;
			this.value = null;
			return;
		}

		if(this.field.warnBeforeChangeTrigger && ((this.value !== undefined && this.value.toString()) != (compareValue && compareValue.toString()))) {
			this.reportFormCtrl.showTriggerWarning(this.field).then(result => {
				if(result) {
					this.updateValue();
				}
				else {
					this.value = this.lastValue;
					this.box && this.value !== undefined && this.box.setValueByChoice(this.value.toString());
				}
			});

			return;
		}

		this.updateValue();
	}

	updateValue() {
		const ctrl = this;

		this.selection = find(this.options, (o) => o.Id === parseInt(this.value));
		if(this.field.EntityQueryConfiguration !== undefined) {
			this.filterDataOnPrimaryDate();
		}

		if(this.isSelectionValid(this.selection)) {
			this.enableField();
			if(this.field.setEntityTimezone === true && this.selection.Id) {
				const timezoneCode = this.entityManager.getUniqueTimezoneForEntity(this.field.Id, this.selection.Id);
				if(timezoneCode === UNIQUE_TIMEZONE_ERRORS.MULTIPLE) {
					notifyMultipleEntityTimezoneError(this.field.Name);
					throw new Error("Selected entity has multiple available timezones in ByEntity configuration");
				}
				else if(timezoneCode === UNIQUE_TIMEZONE_ERRORS.ZERO) {
					notifyNoEntityTimezoneError(this.field.Name);
					this.clearSelected();
					throw new Error("Selected entity has no available timezones in ByEntity configuration");
				}
				this._eventBus.trigger(EVENT_TIMEZONE_SET(ctrl.field.Id), { value: this.selection.TimeZone.Code });
			}
		}

		if(!this.selection && (this.value !== undefined)) {
			this.selection = { Id: this.value };
		}

		this.cleared = undefined;
		if(!!this.isReady) {
			this.triggerValueChanged(ctrl.selection);
		}
		else {
			this.runOnReady.push(() => this.triggerValueChanged(ctrl.selection));
		}
	}

	triggerValueChanged(newSelection, forceTrigger = false) {
		if(!forceTrigger && newSelection?.Id === this.lastValue) {
			return;
		}

		this.lastValue = newSelection?.Id;

		const params = {
			field: this.field,
			value: newSelection !== undefined ? newSelection
				: this.isNotAvailable !== undefined ? { Id: IS_NOT_AVAILABLE_VALUE }
				: undefined
		};

		if(this.initialValueSet) {
			params.initialValue = true;
		}

		this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id, this.repeatId), params);

		if(this.field.visible !== false) {
			this.updateFieldDirty();
		}
	}

	handleCustomInputChanged() {
		const hasLastCustomInputValue = isStringNullishOrEmpty(this.lastCustomInputValue);
		const hasNewValue = isStringNullishOrEmpty(this.value);

		if(hasLastCustomInputValue !== hasNewValue) {
			this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id, this.repeatId), {
				field: this.field,
				value: this.value
			});
		}

		this.lastCustomInputValue = this.value;

		if(this.field.visible !== false) {
			this.updateFieldDirty();
		}
	}

	isDirty(result) {
		return (this.field.visible !== false || this.initialValue !== undefined)
			&& this.field.IsNotReported !== true
			&& this.field.IsHidden !== true
			&& (
				(result?.[this.optionIdType]) !== (this.initialValue?.[this.optionIdType])
				|| (result?.IsNotAvailable) !== (this.initialValue?.IsNotAvailable)
			);
	}

	updateFieldDirty() {
		const result = this.buildResult();
		const isDirty = this.isDirty(result);

		this.setFieldDirty(this.field.Id, isDirty);
	}

	setOptionIdType() {
		switch(this.field.Type.Code) {
			case "ENTITYCONTACT":
			case "ENTITY":
				this.optionIdType = "EntityId";
				break;

			default: //AREA, PORT, REEF, SPECIES,
				this.optionIdType = "DataId";
				break;
		}
	}

	getValidationStyling() {
		return this.field.hasValidationError ? "validation-error"
			: this.field.hasValidationWarning ? "validation-warning" : "";
	}

	expandPivot() {
		const sectionId = (!!this.field.Section && this.field.Section.Id) || 0;
		this._eventBus.trigger(EVENT_EXPAND_MULTI_ENTRY_LIST, { sectionId: sectionId });
	}

	filterDataOnPrimaryDate = (effectiveAsOf, autoSelect) => {
		if(effectiveAsOf) {
			this.effectiveAsOf = effectiveAsOf;
		}

		this.setChoices();

		if(!this.initialValue?.EntityId && !this.isNotAvailable) {
			this.enableField();
		}

		if(!this.isSelectionValid(this.selection)) {
			return false;
		}

		this.featureCallbacks.nestedEntityDateFilter(this.selection, this.effectiveAsOf, this.appState.forms.selected.Seasons);

		this.field.placeHolder = null;

		if(this.selection.valid === false && this.selection.inGrace === false) {
			if(autoSelect === false) {
				this._toastr.warning(
					`The currently selected ${this.field.EntityQueryConfiguration.Primary.Type.Name} is invalid for the selected date.
					Please select a new ${this.field.Name}.`,
					"Warning"
				);
				return false;
			}
			this.clearSelected();
			this.selection = {};
			this.value = undefined;

			this._toastr.warning(`Selected ${this.field.EntityQueryConfiguration.Primary.Type.Name} was invalid for the selected date.
				Selected ${this.field.EntityQueryConfiguration.Primary.Type.Name} has been cleared.`, "Warning");

			this.triggerValueChanged(this.value);

			return true;
		}

		return false;
	}
}

export default angular
	.module("vesl.components.report-form.simple-selection", [])
	.component("simpleSelection", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			repeatId: "<",
			pivotRow: "=",
			pivotColumn: "=",
			subFieldCtrl: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;
